import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Stress: de ‘silent killer’ voor onze vetverbranding!
                </title>
                <link rel="canonical" href={route("blogs.twenty-seven")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE – Personal Training Uden en Schijndel komt met een nieuwe blog waarin stress centraal staat. Stress zorgt namelijk voor verhoogde cortisolwaarden in het lichaam wat negatieve gevolgen heeft op de vetverbranding. Lees je met ons mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE – Personal Training Uden en Schijndel komt met een nieuwe blog waarin stress centraal staat. Stress zorgt namelijk voor verhoogde cortisolwaarden in het lichaam wat negatieve gevolgen heeft op de vetverbranding. Lees je met ons mee?"
                />
                <meta property="og:url" content={route("blogs.twenty-seven")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Stress: de ‘silent killer’ voor onze vetverbranding! - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/stress.jpg" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/stress.webp"
                                    type="image/webp"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/stress.jpg"
                                    type="image/jpeg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/stress.jpg"
                                    alt="Bulken en cutten"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Stress: de ‘silent killer’ voor onze vetverbranding!
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE – Personal Training Uden en Schijndel komt met
                        een nieuwe blog waarin stress centraal staat. Stress
                        zorgt namelijk voor verhoogde cortisolwaarden in het
                        lichaam wat negatieve gevolgen heeft op de
                        vetverbranding. Lees je met ons mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is stress?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Om uit te leggen wat stress is benaderen we stress op
                        een biologische manier. Stress is een response van het
                        lichaam wanneer er veranderde situaties zijn. Door deze
                        veranderingen activeert het overlevingsmechanisme en
                        zorgt ervoor dat je klaar bent voor actie. Spieren
                        spannen zich aan, de hartslag gaat omhoog en de
                        ademhaling gaat sneller. Het lichaam bereidt zich voor
                        op wat komen gaat. Dit kan een acute reactie zijn
                        waarbij stress voor korte duur is en chronische stress
                        waarbij stress op langer termijn aanwezig is en blijft.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe kan stress leiden tot een burn-out?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je stress ervaart reageert je lichaam door de
                        cortisolwaarden in je lichaam te verhogen om beter met
                        stress om te kunnen gaan. Hierbij spelen je nieren een
                        belangrijk rol. Wanneer stress chronisch wordt betekent
                        dit dat de nieren uitgeput kunnen raken. Het gevolg is
                        dat er geen cortisol meer aangemaakt wordt en de
                        cortisolwaarden extreem laten dalen. Het gevolg is dat
                        je lichaam niet meer goed kan omgaan met stress waardoor
                        een burn out ontstaat.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe kan je stress verlagen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Er zijn verschillende manieren om ervoor te zorgen dat
                        je beter met stress kan omgaan. Door de volgende
                        manieren tot te passen verlaag je de cortisolwaarden in
                        je lichaam en verklein je de kans op de lange termijn
                        gevolgen van langdurige stress.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        1. Sporten
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        <a
                            href={route("blogs.first")}
                            className="text-we-are-yellow"
                        >
                            Sporten
                        </a>{" "}
                        is een belangrijke manier om cortisol waardes in het
                        lichaam te laten dalen. Hoewel het tegenstrijdig klinkt
                        omdat je fysieke stress gaat opbouwen leidt dit tot
                        minder mentale stress.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        2. Supplementeren van omega 3 vetzuren
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Omega 3 is een essentieel{" "}
                        <a
                            href={route("blogs.sixteenth")}
                            className="text-we-are-yellow"
                        >
                            supplement
                        </a>{" "}
                        bij klachten van stress. Studies laten zien dat personen
                        die genoeg DHA en APA per dag eten tot 20% minder last
                        van stress hebben!
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        3. Cafeïne beperken
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Het gebruik van cafeïne laat je hartslag stijgen en een
                        hogere hartslag betekent meer stress. Hoewel het innemen
                        van beperkte hoeveelheden cafeïne gezond is ligt teveel
                        nemen van deze stof al snel op de loer. Beperk je koffie
                        inname tot maximaal twee kopjes per dag. Het liefst voor
                        16.00 uur om de{" "}
                        <a
                            href={route("blogs.tenth")}
                            className="text-we-are-yellow"
                        >
                            slaapcyclus
                        </a>{" "}
                        niet te verstoren. Pas dus ook op met het eten van{" "}
                        <a
                            href={route("blogs.twenty-four")}
                            className="text-we-are-yellow"
                        >
                            pre-workout
                        </a>{" "}
                        omdat dit vaak veel cafeïne bevat.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        4. Ademen
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je bewust bezig bent met je ademhaling activeer
                        je het parasympathisch zenuwstelsel. Hierdoor verlaagt
                        je hartslag en dalen cortisol levels in het lichaam.
                        Langzaam en diep ademhalen zijn het meest effectief.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-2xl sm:text-2xl">
                        5. Ontspan en maak plezier
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Belangrijk is om niet altijd ‘aan’ te staan. Een
                        effectieve methode is om minimaal een keer per week een{" "}
                        <a
                            href={route("blogs.eleventh")}
                            className="text-we-are-yellow"
                        >
                            rustdag
                        </a>{" "}
                        in te plannen waarin niets hoeft. Maak tijd door met je
                        vrienden en familie en knuffel vooral veel met je
                        huisdieren en geliefde. Hierdoor komt het hormoon
                        oxytocine vrij. Oxytocine is een natuurlijke stress
                        remmer.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
